import React from 'react';
import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import DialogGlynt, { FormControlStyled, FormLabelStyled } from '../../common/Dialog/DialogGlynt';
import DialogTitleGlynt from '../../common/Dialog/DialogTitleGlynt';
import DialogContentGlynt from '../../common/Dialog/DialogContentGlynt';
import DialogActionsGlynt from '../../common/Dialog/DialogActionsGlynt';
import SelectTrainingSetWithSearch from './SelectTrainingSetWithSearch';
import UploadPicker from '../../upload/UploadPicker';
import ValidTextFieldEB from './ValidTextFieldEB';
import { AppContext } from '../../../App';
import { IExtractionBatch, ITrainingSet } from '../../../types/my-types';
import { LABEL_LIMIT } from '../../../constants';
import { TSetTrainingSet } from '../../../types/util';
import { UploadContext } from '../../upload/UploadContext';

interface Props {
  dismissModal: () => void;
  resetModal: () => void;
  extractionBatches: IExtractionBatch[];
  trainingSet?: ITrainingSet;
  setTrainingSet: TSetTrainingSet;
  coreVersion: string;
}

const ExtractionBatchNewModal: React.FC<Props> = (props) => {
  const { isStaff } = React.useContext(AppContext);
  const { label, setLabel, uploading, open, setOpen, display, step, setStep, isExperimental, setIsExperimental } =
    React.useContext(UploadContext);

  const handleClose = () => {
    props.resetModal();
    props.dismissModal();
  };

  const handleNext = () => {
    setStep(2);
  };

  const isNextDisabled = label.length === 0 || label.length > LABEL_LIMIT || !props.trainingSet;

  return (
    <DialogGlynt
      open={open && display}
      closeModal={handleClose}
      cypressId="create-extraction-batch-dialog"
      width="600px"
    >
      <DialogTitleGlynt
        title={`Create New Extraction Batch - Step ${step} of 2`}
        closeModal={handleClose}
      />

      {step === 1 ? (
        <>
          <DialogContentGlynt scrollable>
            <FormControlStyled fullWidth data-cy="modal-extraction-batch-name">
              <FormLabelStyled>Batch Name</FormLabelStyled>
              <ValidTextFieldEB
                placeholder="Enter extraction batch name"
                setLabel={setLabel}
                disabled={uploading}
                labels={props.extractionBatches.map((eb) => eb.label)}
                width="100%"
              />
            </FormControlStyled>

            <FormControlStyled fullWidth data-cy="modal-select-training-set">
              <FormLabelStyled>Model Name</FormLabelStyled>
              <SelectTrainingSetWithSearch
                setTrainingSet={props.setTrainingSet}
                disabled={uploading}
                width="100%"
              />
            </FormControlStyled>

            <FormControlStyled fullWidth>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isExperimental}
                    onChange={(e) => setIsExperimental(e.target.checked)}
                    disabled={uploading}
                    data-cy="is-experimental-checkbox"
                  />
                }
                label="Experimental"
              />
            </FormControlStyled>
          </DialogContentGlynt>

          <DialogActionsGlynt
            handleSubmit={handleNext}
            closeModal={handleClose}
            cancelCypressId="create-extraction-batch-dialog-cancel"
            submitCypressId="create-extraction-batch-dialog-next"
            clearCypressId="create-extraction-batch-dialog-clear"
            submitButtonText="Next"
            submitDisabled={isNextDisabled}
          />
        </>
      ) : (
        <>
          <DialogContentGlynt scrollable>
            <Grid container>
              <UploadPicker
                trainingSet={props.trainingSet}
                isExtraction={true}
                dismissModal={props.dismissModal}
              />
            </Grid>
          </DialogContentGlynt>

          <DialogActionsGlynt
            handleSubmit={handleClose}
            closeModal={handleClose}
            cancelCypressId="create-extraction-batch-dialog-cancel"
            submitCypressId="create-extraction-batch-dialog-submit"
            clearCypressId="create-extraction-batch-dialog-clear"
            showSubmitButton={false}
            submitButtonText="Cancel"
            submitDisabled={uploading}
          />
        </>
      )}
    </DialogGlynt>
  );
};

export default ExtractionBatchNewModal;
